import React, { useState }  from 'react';
import { 
  bluSmartImage, 
  goAssuredImage 
}                           from '../../config/constants'
import { IBluSmartTgp }     from '../../pages/SearchPage/redux/types';
import BluSmartModal        from '../BluSmartModal/BluSmartModal';
import * as S               from './BluSmartBannerStyle'
interface IBluSmartBanner {
  dbgData : IBluSmartTgp
}

const BluSmartBanner : React.FC<IBluSmartBanner> = ({
  dbgData = {} as IBluSmartTgp
}) => {
  const {message = "", textColor = "", subTextColor = ""} = dbgData
  const [showKnowMoreModal, setShowKnowMoreModal] = useState<boolean>(false)

  // opening and closing bluSmart modal
  const handleKnowMore = (showModal : boolean) => {
    setShowKnowMoreModal(showModal);
  }

  return (
    <React.Fragment>
      <S.BluSmartTile>
        <div className='branding hrtlCenter'>
          Fulfilled by 
          <span className='appendLeft10'>
            <S.BluSmartImg src={bluSmartImage}/>
          </span>
        </div>
        <div className='assuredStrip'>
          <div className='dtls'>
            <S.GoAssuredImg src={goAssuredImage}/>
            <span className='appendLeft10 font12'>
              {message?.length ? (
                <S.MessageText textColor={textColor} subTextColor={subTextColor}
                  className="width100 fl pDTB20 fotDPLink"
                  dangerouslySetInnerHTML={{
                    __html: message
                  }}>
                </S.MessageText>
              ) : null}
            </span>
            <span className='knowMore' onClick={() => handleKnowMore(true)}>know more</span>
          </div>
        </div>
      </S.BluSmartTile>
      {
        showKnowMoreModal ? (
          <BluSmartModal dbgData={dbgData} setShowMoreModal={handleKnowMore}/>
        ) : null
      }
    </React.Fragment>
  )
}

export default BluSmartBanner
